import { render } from "./Image.vue?vue&type=template&id=40f268d2"
import script from "./Image.vue?vue&type=script&setup=true&lang=js"
export * from "./Image.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Mask/Tiles/components/Image.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40f268d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40f268d2', __exports__)) {
    api.reload('40f268d2', __exports__)
  }
  
  module.hot.accept("./Image.vue?vue&type=template&id=40f268d2", () => {
    api.rerender('40f268d2', render)
  })

}


export default __exports__